import { modalWindows as EnUsModalWindows } from '../en-us/modalWindows';

export const modalWindows = {
  ...EnUsModalWindows,
  editShippingMethod: {
    titleHeader: 'Edit Shipping Method',
    subtitle: 'Choose:',
    saveMethodButton: 'Save Shipping Method'
  },
  editShippingAddress: {
    bannerText: 'Delivery address will be changed starting from the next shipment',
    titleHeaderCreate: 'Create shipping address',
    subscriptionUpdate: 'Set as the shipping address on my subscription',
    address2: 'Apartment, Suite, Etc. (optional)',
    city: 'City',
    usedSavedLabel: 'Use saved address ',
    zip: 'Zip Code',
    titleAddress: 'Edit Address',
    titleHeaderEdit: 'Edit shipping address',
    last_name: 'Last Name',
    company: 'Company (optional)',
    first_name: 'First Name',
    phone: 'Phone',
    province: 'State',
    deleteAddressText: 'Are you sure you are want to delete saved address',
    selectAddress: {
      reloadMessage: 'Please, reload page',
      noSavedAddressText: 'You have no saved addresses at this time',
      useSavedAddressButton: 'Use saved address',
      noSavedAddressButton: 'No saved addresses',
      titleForSelectAddressModal: 'Select Shipping Address',
      cancelButton: 'Cancel',
      submitButton: 'Ok',
      useSelectButton: 'Use selected'
    },
    massUpdate: 'Use for all active subscriptions',
    deleteAddressTitle: 'Delete address',
    updateButton: 'Update',
    address1: 'Address',
    country: 'Country',
    cancelButton: 'Cancel'
  },
  addPaymentMethod: {
    title: 'Add Payment Method',
    instructions:
      'An email will be sent to {{email}} to securely add your payment method on file. Confirm below to send email.'
  },
  editPaymentMethod: {
    title: 'Edit Payment Method',
    instructions:
      'An email will be sent to {{email}} to securely edit your payment method on file. Confirm below to send email.',
    shopPayInstructions: `An email will be sent to {{email}} to securely edit your payment method within Shop Pay. Confirm below to send email. \n
    If you would like to switch payment methods from Shop Pay to a different payment method, such as PayPal or Apple Pay, please cancel your subscription by returning to your Subscription Details. Once cancelled, create a new subscription and enter the preferred payment method.`
  },
  paymentMethod: {
    cancelButton: 'Cancel',
    submitButton: 'Send Email',
    successTitle: 'Confirmation Email Sent',
    successMessage: 'Check your email shortly for an email confirmation'
  },
  cancelSubscription: {
    keepButton: 'Keep It',
    commentsPlaceholder: 'Describe the problem',
    cancelButton: 'Cancel Subscription',
    reasons:
      "I haven't noticed any benefit,I'm moving or traveling,I already have more than I need,I have a medical reason,This is too expensive,I don't like the taste,I don't want a subscription,Other reason",
    v53Reasons: 'Dislike the new formula,Dislike the new tropical flavor',
    agzCancelationReasons:
      "I don’t like the taste of AGZ,I haven’t noticed any benefits of AGZ,I already have more AGZ than I need,I don’t want a subscription,I have a medical reason,This is too expensive,I'm moving for traveling,Other reason",
    commentsLabel: 'Comments',
    keepSubscriptionButton: 'Keep Subscription',
    text: 'Please confirm cancellation of your subscription below. If you would like to provide a reason, we welcome your feedback so we can improve the experience for others in the future (optional):',
    title: 'We are sorry to see you go!'
  },
  switchProduct: {
    packName: 'Travel Packs',
    modalTitle: 'Switch To {{productName}}',
    title:
      'Your next order on {{formatNextOrderDate}} will have {{qtyModal}} box of {{switchToText}}',
    infoMessage: 'Product will be switched for your next order only.',
    cancelButton: 'Cancel',
    confirmButton: 'Confirm',
    pouchName: 'Pouches',
    quantityText: 'Quantity of {{switchToText}} to switch:',
    description:
      'You can change the number of your {{switchToText}} on the manage subscription page.'
  },
  switchFromFreeShipping: {
    text: 'Your current free shipping plan requires a 3 month supply of AG1 Pouch to ship every 90 days. By changing the product to Travel Packs, you will reset to $89 per 30 count of Travel Packs and shipping cost of $9 per order.'
  },
  skipShipment: {
    textConfirm: 'Next order date will be changed to {{date}}',
    skipButton: 'Cancel',
    questionConfirm: 'Are you sure you want to skip the next shipment?',
    continueButton: 'Continue',
    headConfirm: 'Skip Shipment'
  },
  acceptAddressValidation: {
    title: 'Confirm Your Address',
    continueButton: 'Save & Continue',
    enteredTitle: 'Address Entered',
    editButton: 'Edit Address',
    suggestedTitle: 'Suggested Address',
    text: "We couldn't verify the exact address you entered. Please make sure it's correct or make any necessary changes."
  },
  shopAlert: {
    deleteButtonTitle: 'Continue',
    cancelButtonTitle: 'Cancel',
    makeGiftCartButtonTitle: 'As a Gift',
    subToGift: {
      headerTitle: 'Before you add a subscription',
      content:
        'Gift orders can only include products that ship one time. Adding a subscription to your cart will remove gift products.'
    },
    giftToSub: {
      headerTitle: 'Before you add a gift',
      content:
        'Subscription orders cannot be sent with a gift message. Adding a gift to your cart will remove subscription products.'
    },
    giftToOtp: {
      headerTitle: 'Make the whole order as a gift',
      content:
        'You already have one time purchase products in Cart. Do you want to make the whole order as a gift?'
    }
  },
  addProductFromSlider: {
    toastNextOrder: 'Product added to next order of ',
    toastSubscription: 'Product added to {{name}}',
    toastSeveralSubscription: 'Product added to',
    severalSubscriptions: 'subscriptions',
    toastToAllSubscription: 'Product added to all subscriptions',
    toastToAllNextOrder: 'Product added to next order of all subscriptions',
    titleSubscription: 'Add product To Subscription',
    titleNextOrder: 'Add product to Next Order',
    checkbox: 'Add to all active subscriptions',
    text: 'Select the subscription to which you want to add the product.',
    addProductButton: 'Add Product'
  },
  cart: {
    subscriptionTitle: 'Subscription',
    title: 'Your Cart',
    checkoutButtonLabel: 'Checkout',
    summary: {
      taxEstimatedLabel: 'Estimated Tax',
      taxLabel: 'Tax',
      totalLabel: 'Total',
      taxNotReady: '---',
      shippingLabel: 'Shipping',
      discountLabel: 'Your discount',
      freePrice: 'Free',
      subtotalLabel: 'Subtotal'
    },
    emptyState: {
      oneTimeProductsTitle: 'Members Favorites',
      addOneTimeProductButton: 'Add to Cart',
      label: 'Add items to your cart'
    },
    emptyStateLabel: 'Add items to your cart',
    frequencyLabel: 'Ships every 30 days',
    promoCode: {
      promoCTA: 'Have a promo code?',
      promoError: 'Discount code is invalid',
      promoInputLabel: 'Promo code',
      promoButtonLabel: 'Apply'
    }
  },
  changeOrderDate: {
    title: 'Select Order Date',
    confirmButton: 'Confirm',
    nextOrderDateSuccessText: 'Your following order date will be {{date}}.',
    nextOrderDateChangeText:
      'Your following order date for this subscription will be moved to {{date}} ',
    description: 'You can change the date of your next order',
    newDateChangeText: 'The next order date is',
    newDateSuccessText: 'The next order date changed to {{date}} '
  },
  shipNow: {
    shipNowButton: 'Confirm Order',
    subtitle: 'Order placed successfully',
    description:
      'This order is estimated to ship within 24 hours M-F after payment. Please allow up to 48 hours on weekends and holidays. Your following order will be placed in {{shipInterval}} on {{date}}',
    title: 'Ship Next Order Now',
    confirm:
      'When you confirm below, your order will be processed within 1 business day. Please allow up to 48 hours on weekends and holidays.',
    preparing: 'Preparing',
    preparingDescription: 'You have a current order estimated to ship',
    shipped: 'Shipped',
    shippedDescription: 'You have a current order that shipped',
    delivered: 'Delivered',
    deliveredDescription: 'Your last order was delivered',
    shipNext: 'Ship next order now:',
    nextOrder: 'Next order:',
    followedBy: 'Followed by:'
  },
  editFrequency: {
    titleView: 'Edit Order Frequency',
    titleDatepicker: 'Change Next Order Date',
    day: 'Day',
    infoMessage: 'Shipment frequency has been changed to {{date}}.',
    shippingFrequency: 'Shipping Frequency',
    item: 'Every',
    nextOrderButton: 'Next Order Date',
    nextOrderLink: 'Change next order date',
    nextOrder: 'Next order:',
    followedBy: 'Followed by:',
    description: 'Changes will go into effect starting from your next order date.',
    followingText: 'following',
    ribbonMessage:
      'This change applies only to the orders <bold>{{followingText}}</bold> your next order date.',
    extraInfo:
      "When you confirm below, you'll be charged today and the order will ship within 1 business day. Please allow up to 48 hours on weekends and holidays.",
    saveButton: 'Save Changes',
    confirmButton: 'Confirm'
  },
  acceptChanges: {
    text: 'Updating your subscription details will reset your next order and remove "one time" items.',
    title: 'Before You Change Your Subscription',
    continueButton: 'Continue',
    cancelButton: 'Cancel '
  },
  acceptFreeShippingChanges: {
    text: 'Your current free shipping plan requires a 3 month supply of product to ship every 90 days. By changing the quantity, you will reset to $79 per Pouch and shipping cost of $9 per order.',
    title: 'Before You Change Your Subscription',
    continueButton: 'Continue',
    cancelButton: 'Cancel',
    successMessage: 'Your subscription has been updated'
  },
  activateSubscription: {
    successTitle: 'Your subscription {{name}} is active and available to manage.',
    errorMessage: 'Unable to change order date',
    activateButton: 'Activate Subscription',
    title: 'Reactivate Subscription',
    infoMessage: 'You can change the date of your next order before your subscription is activated',
    successDescription: 'The next order day is {{date}}.'
  },
  addProductFromModal: {
    noteTitle: 'How to swap from AG1 Pouch to AG1 30 Ct Travel Packs',
    noteSubtitle:
      'To swap between Pouch and 30 Ct Travel Packs, add the desired product to your subscription by selecting "Add to Subscription". Once added, remove the other product from your subscription by selecting the trash can icon on your Subscription Details page.',
    addToOrder: 'Add Product to Order',
    addToSubscription: 'Add to Subscription',
    addToNextOrder: 'Add to Next Order',
    addedToNextOrder: 'Added to Next Order',
    addedToSubscription: 'Added to Subscription',
    preferredFlavorText: 'Member preferred flavor'
  },
  migrateToV53: {
    title: 'Upgrade My AG1',
    text: 'Click continue to upgrade to the next generation of AG1.',
    button: 'Continue'
  }
};
